export const validateContactFields = (fields) => {
    const name = fields.name.trim();
    const email = fields.email.trim();
    const message = fields.message.trim();
    return {
        name: name.length < 2 || name.length > 120 || /[\r\n]/.test(name),
        email: email.length > 254 ||
            /[\r\n]/.test(email) ||
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
        message: message.length < 10 || message.length > 5000
    };
};
export const submitContact = async (payload) => {
    const controller = new AbortController();
    const timeout = globalThis.setTimeout(() => controller.abort(), 12000);
    try {
        const response = await fetch('/api/contact-submit.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(payload),
            signal: controller.signal
        });
        if (!response.ok)
            throw new Error(`Contact delivery failed (${response.status})`);
        const result = (await response.json());
        if (result.received !== true)
            throw new Error('Invalid contact response');
    }
    finally {
        globalThis.clearTimeout(timeout);
    }
};
